export enum LangsEnum {
    EN = 'en',
    FR = 'fr',
    DE = 'de',
    ES = 'es'
}